import { create } from './clearStore';

const initialState = {
  user: {},
  theme: 'Dark',
  notificationAlert: true,
  token: {},
  language: 'English',
  isLoggedIn: false,
  isCrossAppLoginInProgress: false,
};

export const useUserStore = create(
  (set) => ({
    ...initialState,
    updateUser: (user) => set({ user }),
    setTheme: (theme) => set({ theme }),
    setNotificationAlert: (notificationAlert) => set({ notificationAlert }),
    addToken: (token) => set({ token, isLoggedIn: true }),
    setLanguage: (language) => set({ language }),
  }),
  {
    name: 'userData',
    initialState,
    excludedKeys: ['language'],
  },
);
